import { useSessionContext } from '../context/session-context'
import { Hustler } from '../dao/core-dao'
import { fileDao } from '../dao/file-dao'
import { coreService } from '../service/core-service'
import { UseMutationResult, useMutation } from '@tanstack/react-query'

export const useUploadProfilePhoto = (): UseMutationResult<Hustler, Error, File> => {
  const { refreshMyData } = useSessionContext()

  return useMutation<Hustler, Error, File>(
    async (file: File) => {
      const fileId = await fileDao.uploadFile(file)
      const updatedHustler = await coreService.updateMe({
        profile: {
          profilePhotoFileId: fileId,
        },
      })
      return updatedHustler
    },
    {
      onSuccess: () => {
        refreshMyData()
      },
    },
  )
}
